export default __webpack_public_path__ + "static/media/CWIS-Whale.1362306e.png";